import { Flex, Text } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { FormFieldFile } from '.';
import { ISubmissionFile } from '@publishing-engine/domain/models/submission';
import { FileDisplay } from './FileDisplay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/pro-light-svg-icons';

interface Props {
  value?: ISubmissionFile;
  previousValue?: ISubmissionFile;
  onClose: () => void;
  config: FormFieldFile;
  submissionContextId: string;
}

const zeroState = (
  <Flex
    flexDirection="row"
    justifyContent="space-between"
    backgroundColor="surfaceTertiaryFill"
    padding={4}
    color="neutralSecondaryContent"
  >
    <Flex alignItems="center" gap={2} flexDirection="row">
      <FontAwesomeIcon
        color="neutralSecondaryContent"
        icon={faFile}
        fontSize={32}
      />
      <Text textStyle="textBody">No data available</Text>
    </Flex>
  </Flex>
);

export const FileDiffModal = ({
  value,
  previousValue,
  onClose,
  config,
  submissionContextId
}: Props) => {
  const label = config.params.labels.main;

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        {!previousValue ? zeroState : <FileDisplay file={previousValue} filenameDisplay='fileName' submissionContextId={submissionContextId} />}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        {!value ? zeroState : <FileDisplay file={value} filenameDisplay='fileName' submissionContextId={submissionContextId} />}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
